import { render, staticRenderFns } from "./BlockType26.vue?vue&type=template&id=7581dcf5&scoped=true&"
import script from "./BlockType26.vue?vue&type=script&lang=ts&"
export * from "./BlockType26.vue?vue&type=script&lang=ts&"
import style0 from "./BlockType26.vue?vue&type=style&index=0&id=7581dcf5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7581dcf5",
  null
  
)

export default component.exports